
























































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";

import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import HsaDebitCardWizard from "@/employee/components/settings/HsaDebitCardWizard.vue";
import Widget from "@/shared/components/Widget.vue";
import Button from "@/shared/components/ui/Button.vue";
import {
  DebitCardInfo,
  AdvisorEventType
} from "@/shared/types";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabLinkedAccounts from "@/employee/components/settings/hsaBank/HsabLinkedAccounts.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useCardProviderOptionsStore } from "@/employee/store/cardProviderOptions";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useDebitCardsStore } from "@/shared/store/debitCards";
import * as RouteNames from "@/employee/route-names";

@Component({
  components: {
    SettingsNavigation,
    Widget,
    Button,
    HsaDebitCardWizard,
    SettingsHeader,
    GenericLoadingSpinner,
    HsabLinkedAccounts,
  }
})
export default class HsaDebitCards extends Vue {
  debitCardToEdit: DebitCardInfo | null = null;

  custodianSettingsStore = useCustodianSettingsStore();
  cardProviderOptionsStore = useCardProviderOptionsStore();
  advisorStore = useUserAdvisorStore();
  debitCardsStore = useDebitCardsStore();


  get widgetTitle () {
    if (this.debitCardToEdit === null) {
      return "Debit Card Activation";
    }

    return `Manage Debit Card for ${this.debitCardToEdit.firstName}`;
  }

  @Watch("debitCardToEdit")
  showWizard () {
    return this.debitCardToEdit !== null;
  }

  closeWizard (event) {
    this.debitCardToEdit = null;
  }

  mounted () {
    this.custodianSettingsStore.getCustodianSettings();
    this.debitCardsStore.getDebitCards();
    this.cardProviderOptionsStore.getCardProviderOptions();
    this.onCardProviderOptionsLoaded();
  }

  @Watch("cardProviderOptionsStore.isLoaded")
  onCardProviderOptionsLoaded () {
    if (this.cardProviderOptionsStore.isLoaded && ! this.cardProviderOptionsStore.canManageCard) {
      // redirect the user to top-level Settings page
      this.$router.replace({ name: RouteNames.Settings });
    }
  }

  openWizard (debitCardInfo: DebitCardInfo) {
    this.debitCardToEdit = debitCardInfo;
  }

  lastFour (debitCardInfo: DebitCardInfo) {
    if (debitCardInfo.isAwaitingReissue) {
      return "Processing";
    }

    return `—${debitCardInfo.lastFour}`;
  }

  activate (debitCardInfo: DebitCardInfo) {
    this.advisorStore.saveEvent(AdvisorEventType.CardActivationClick);
    // tslint:disable-next-line:no-empty
    this.debitCardsStore.activateDebitCard(debitCardInfo).catch(() => {
    });
  }
}

